import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuController, ModalController } from '@ionic/angular';
import { ShoppingCart } from 'src/app/models/cart.model';
import { ProductSubType, ProductType } from 'src/app/shared-lib/domains/product';
import { CartService } from 'src/app/shared/cart.service';
import { UtilsService } from "../../shared/services/utils.service";

@Component({
  selector: 'app-item-shop-product',
  templateUrl: './item-shop-product.component.html',
  styleUrls: ['./item-shop-product.component.scss'],
  standalone: false
})
export class ItemShopProductComponent implements OnInit {
  @Input() item: ShoppingCart.OrderItem;
  @Input() i;
  @Input() disableActions;
  @Input() showQty;

  viewDetails: boolean = false;
  formattedCustomElements: any[] = [];
  customElementsToEs = {
    ['paperSize']: 'Tamaño de página',
    ['paperColor']: 'Color del papel',
    ['paperWeight']: 'Gramaje',
    ['paperPattern']: 'Motivo del papel',
    ['sheetNumber']: 'Número de folios',
    ['rings']: 'Anilla',
    ['coverFront']: 'Tapa delantera',
    ['coverBack']: 'Tapa trasera'
  };

  constructor(
    public cartService: CartService,
    private router: Router,
    private menuCtrl: MenuController,
    private modalController: ModalController,
    private utils: UtilsService
  ) {
  }

  ngOnInit() {
    if (this.item.product.customElementsSelected) {
      this.formattedCustomElements = this.formatCustomElements(this.item.product.customElementsSelected);
    }
  }

  async onDelete(item) {

    if (item.product.type === ProductType.WALLETBONUS) {
      this.cartService.applyWallet(false);
    }
    this.cartService.deleteProductCart(item);
  }

  onQtyChange(event) {

    const product = this.item.product;
    const qty = event.qty - this.item.qty;
    this.cartService.updateProductCart(product, qty);
  }

  // Cached result keyed by the props reference to avoid creating a fresh array
  // on every change-detection cycle, which would defeat *ngFor identity checks
  // and trigger unnecessary re-renders (and in pathological cases — combined
  // with frequent Firestore variant updates — visible UI freezes).
  private _propsCacheKey: object | null = null;
  private _propsCache: { key: string; value: any; }[] = [];
  formatProperties(props: object) {
    if (props === this._propsCacheKey) return this._propsCache;
    this._propsCacheKey = props;
    this._propsCache = props ? Object.entries(props).map(([key, value]) => ({ key, value })) : [];
    return this._propsCache;
  }

  trackProperty(_index: number, prop: { key: string; value: any; }) {
    return prop.key;
  }

  formatCustomElements(props: object) {
    const properties = [];
    Object.entries(props).forEach(([key, value]: [string, any]) => {
      properties.push({ key: this.customElementsToEs[key], value: this.utils.getColorName(value.name) });
    });
    return properties;
  }

  protected readonly ProductSubType = ProductSubType;

  toggleViewDetails() {
    this.viewDetails = !this.viewDetails;
  }
}

